import type { PermissionTuple } from '~/utils/ability'
import type { RouteTo } from '~/utils/rbac'
import type { GuardedTab } from '~/utils/rbacTabs'

export type UsersTab = 'app' | 'payment-defaults' | 'bo'

/**
 * Source unique consommée par le `staticData.permission` de chaque route d'onglet, par la barre
 * d'onglets et par `/users` : pas de dérive possible entre l'onglet affiché et la page qu'il ouvre.
 */
export const USERS_TAB_PERMISSIONS = {
  app: ['read', 'users.app-users.user'],
  'payment-defaults': ['read', 'users.payment-defaults.default'],
  bo: ['read', 'users.bo-users.user'],
} as const satisfies Record<UsersTab, PermissionTuple>

type UsersTabDefinition = GuardedTab<UsersTab> & {
  to: RouteTo
  permission: PermissionTuple
}

/** Ordre de déclaration = ordre d'affichage, et ordre de repli de la redirection `/users`. */
export const USERS_TABS: UsersTabDefinition[] = [
  {
    value: 'app',
    label: "Utilisateurs de l'app",
    to: '/users/app',
    permission: USERS_TAB_PERMISSIONS.app,
  },
  {
    value: 'payment-defaults',
    label: 'Défauts de paiement',
    to: '/users/payment-defaults',
    permission: USERS_TAB_PERMISSIONS['payment-defaults'],
  },
  {
    value: 'bo',
    label: 'Utilisateurs du BO',
    to: '/users/bo',
    permission: USERS_TAB_PERMISSIONS.bo,
  },
]
